import { Avatar, Box, Typography } from '@mui/material';
import { theme } from '@store';
import { FC } from 'react';

interface ProfileAvatarProps {
  encoded_image?: string;
  firstName: string;
  lastName: string;
  size?: 'small' | 'medium' | 'large';
  status?: 'active' | 'away' | 'offline';
}

const profileAvatarSize = {
  small: {
    icon: 32,
    text: 12,
    statusIcon: 10,
  },
  medium: {
    icon: 40,
    text: 14,
    statusIcon: 12,
  },
  large: {
    icon: 75,
    text: 20,
    statusIcon: 16,
  },
};

const iconColor = {
  active: theme.palette.success.main,
  away: theme.palette.warning.main,
  offline: theme.palette.grey[400],
};

export const ProfileAvatar: FC<ProfileAvatarProps> = ({
  encoded_image,
  size = 'small',
  firstName = 'I',
  lastName = 'I',
  status,
}) => {
  const { icon, text, statusIcon } = profileAvatarSize[size];

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      {encoded_image ? (
        <Avatar
          sx={{ height: icon, width: icon, minWidth: icon, minHeight: icon }}
          alt={`${firstName} ${lastName}`}
          src={encoded_image}
        />
      ) : (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            width: icon,
            height: icon,
            minWidth: icon,
            minHeight: icon,
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: text,
              color: theme.palette.common.white,
            }}
          >
            {firstName[0]}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: text,
              color: theme.palette.common.white,
            }}
          >
            {lastName[0]}
          </Typography>
        </Box>
      )}
      {status && (
        <Box
          sx={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            width: statusIcon,
            height: statusIcon,
            border: `1px solid ${theme.palette.common.white}`,
            borderRadius: '50%',
            backgroundColor: iconColor[status],
          }}
        />
      )}
    </Box>
  );
};
